export const Images = {
  /** Primary navbar mark (Nibble). */
  brandLogo: require('../icons/nibble-logo.png'),
};
